/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.DrawerManager {
    angular.module("meevo.plugins.drawerManager", []);
}